import React, { useState } from 'react';
import '../styles/App.css';
import '../styles/fonts.css';
import DataTable from './UI-components/Table/table';
import { useAllEmployess } from '../middlewares/employess';

const Employees = () => {

    // Event
    const [editingEvent, setEditingEvent] = useState(null); // State to manage the editing event
    const [formFields, setFormFields] = useState({
        category: "",
        show: "",
        venue: "",
        city: "",
        state: "",
        opening_date: null,
        closing_date: null,
        prefs: "",
        notes: "",
    });
    const [showEditModal, setShowEditModal] = useState(false);
    const [events, setEvents] = useState([])
    const { data } = useAllEmployess()

    const handleChange = (key, value) => {
        console.log(key, value);
        setFormFields((prevFields) => ({
            ...prevFields,
            [key]: value
        }));
    };

    const handleUpdate = (updatedEvent) => {
        const index = events.findIndex((event) => event.id === updatedEvent.id);
        if (index !== -1) {
            const updatedEvents = [...events];
            updatedEvents[index] = updatedEvent;
            setEvents(updatedEvents);
            setShowEditModal(false)
        }
    };

    const handleUpdateSettings = () => {
        // Create an updated event object with form field values
        const updatedEvent = {
            ...editingEvent, // Keep other properties unchanged
            category: formFields.category,
            show: formFields.show,
            venue: formFields.venue,
            city: formFields.city,
            state: formFields.state,
            opening_date: formFields.opening_date,
            closing_date: formFields.closing_date,
            prefs: formFields.prefs,
            notes: formFields.notes,
        };
        // Call handleUpdate to update the event with the updatedEvent object
        handleUpdate(updatedEvent);
    };  

    console.log(data);

    return (
        <div>
            <div>
                <DataTable
                    events={events}
                    handleUpdateSettings={handleUpdateSettings}
                    formFields={formFields}
                    handleChange={handleChange}
                    setEvents={setEvents}
                    setFormFields={setFormFields}
                    showEditModal={showEditModal}
                    setShowEditModal={setShowEditModal}
                    setEditingEvent={setEditingEvent}
                />
            </div>
        </div >
    );
};

export default Employees;
